import { Transform } from "class-transformer";
import LengthValue from "../core/Length/LengthValue";
import { LengthParser } from "../core/Length/LengthParser";

export class DrawConstant {
    public IsDefaultHeightConstant!: boolean;
    @Transform(params => LengthParser.parse(params.value))
    public GapTopBox!: LengthValue;
    @Transform(params => LengthParser.parse(params.value))
    public GapBottomBox!: LengthValue;
    @Transform(params => LengthParser.parse(params.value))
    public PlinthHeight!: LengthValue;
    @Transform(params => LengthParser.parse(params.value))
    public GapBetweenFrontElements!: LengthValue; // IDH
    @Transform(params => LengthParser.parse(params.value))
    public SideBoxGap!: LengthValue; // FSEW
    @Transform(params => LengthParser.parse(params.value))
    public GrooveGap!: LengthValue; // GTIE
    @Transform(params => LengthParser.parse(params.value))
    public BoxThickness!: LengthValue; // BT
    @Transform(params => LengthParser.parse(params.value))
    public DoorThickness!: LengthValue; // DT
    @Transform(params => LengthParser.parse(params.value))
    public ShelfThickness!: LengthValue; // ST
    @Transform(params => LengthParser.parse(params.value))
    public GlassShelfThickness!: LengthValue; // STG
    @Transform(params => LengthParser.parse(params.value))
    public FixedShelfThickness!: LengthValue; // STF
    @Transform(params => LengthParser.parse(params.value))
    public DrawerRecess!: LengthValue; // DR
    @Transform(params => LengthParser.parse(params.value))
    public DrawerRailHeight!: LengthValue; // DRH
    @Transform(params => LengthParser.parse(params.value))
    public PulloutRecess!: LengthValue; // POR
    @Transform(params => LengthParser.parse(params.value))
    public PulloutRailHeight!: LengthValue; // PORH
    @Transform(params => LengthParser.parse(params.value))
    public PlinthDepth!: LengthValue; // FPD
    @Transform(params => LengthParser.parse(params.value))
    public GrooveWidth!: LengthValue; // VGW
    @Transform(params => LengthParser.parse(params.value))
    public CountertopHeight!: LengthValue; // Height of the default down furniture height
}
